import { colors } from "@/theme/globalStyles";
import styled from "styled-components";

export const CardButton = styled.div`
    box-shadow: 0px 0px 2px 2px #e0e0e0;
    display:flex;
    justify-content: center;
    align-items:center;
    flex-direction:column;
    height:192px;
    border-radius:8px;
    color: ${colors.orange};
    cursor: pointer;
    padding: 0px 50px;
    text-align:center;

    &:hover {
        background: ${colors.orange};
        color: #fff;
    }
`;

export const Title = styled.div`
    font-size: 24px;
    font-weight: bold;
    font-family: 'Lato', sans-serif;
`;

export const Subtitles = styled.div`
    font-size: 20px;
    font-weight: bold;
    font-family: 'Lato', sans-serif;
    color: #5b5b5f;
    padding: 24px 0 0 0;
`;

export const Spacing = styled.div`
    height: 32px;
`;

export const Loader = styled.div`
    display: flex;
    height: 40px;
    justify-content: center;
`;
